import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { watch } from 'vue';
import useAlerts from './useAlerts';
import apolloClient from './useApolloClient';

const { addAlert } = useAlerts();

const GET_DIARIES = gql`
  query DiariesQuery($companyid: ID, $contactid: ID) {
    diaries(companyid: $companyid, contactid: $contactid) {
      DIARYID
      DIARYTEXT
      COMPANYID
      CONTACTID
      CREATEDATE
      PROJECT
      TYPE
      ASSIGNEDID
      contact {
        CONTACTID
        FIRSTNAME
        LASTNAME
        INACTIVE
      }
      company {
        COMPANYID
        NAME
      }
    }
  }
`;

export default function useDiaryQuery() {
  return function (params) {
    provideApolloClient(apolloClient);

    const { result, loading, error, refetch } = useQuery(GET_DIARIES, params, { fetchPolicy: 'no-cache' });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching diaries:', error.value);
        addAlert('Error fetching diary entries', 'high', 5);
      }
    });

    return {
      result,
      loading,
      error,
      refetch,
    };
  };
}
